import { render } from "./EntrancePlantStructureBuilding.vue?vue&type=template&id=848a0d7c&ts=true"
import script from "./EntrancePlantStructureBuilding.ts?vue&type=script&lang=ts"
export * from "./EntrancePlantStructureBuilding.ts?vue&type=script&lang=ts"

import "./EntrancePlantStructureBuilding.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__